import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useParentBg } from "../../shared/hooks/current-color";
import { BadgeBox } from "./Badge.styled";
import { useBadgeColors, getBadgeContent } from "./utils";
import { Icon } from "../Icon";
import { useTheme } from "../ThemeProvider";
import Typography from "../Typography";
const Badge = ({
  variant = "primary",
  color = "info",
  size = "m",
  count,
  icon,
  ...rest
}) => {
  const theme = useTheme();
  const parentBg = useParentBg();
  const { badgeColor, textColor, iconColorKey } = useBadgeColors({
    variant,
    color,
    parentBg
  });
  const { countProp, iconProps } = getBadgeContent({
    size,
    count,
    icon,
    iconColorKey
  });
  const badgeTokens = theme.badge;
  const typography = badgeTokens.typography[size];
  const height = badgeTokens.size[size];
  const paddingX = badgeTokens.horizontalPadding[size];
  const borderRadius = badgeTokens.borderRadius[size];
  const content = useMemo(() => {
    if (iconProps && icon) {
      return /* @__PURE__ */ jsx(Icon, { icon, size: iconProps.size, color: iconProps.color });
    }
    return countProp;
  }, [iconProps, icon, countProp]);
  return /* @__PURE__ */ jsx(
    BadgeBox,
    {
      badgeColor,
      textColor,
      height,
      iconProps,
      paddingX,
      borderRadius,
      ...rest,
      children: /* @__PURE__ */ jsx(Typography, { variant: typography, children: content })
    }
  );
};
Badge.displayName = "Badge";
var Badge_default = Badge;
export {
  Badge_default as default
};
